import { saveInvoice } from '../api/invoice.api';

export const InvoiceService = {
  saveInvoice: async (invoiceData) => {
    return saveInvoice(invoiceData);
  },
};
